import React from 'react'
import GlobalStyles from 'components/GlobalStyles'
import MinimalFooter from 'components/MinimalFooter'
import { THEME } from 'utils'

const FormPageLayout = ({ title, children }) => {
  return (
    <>
      <div className='screenBackdrop'>
        <div className='logoContainer'>
          <img className='logo' src='/static/images/sportsbook/sportsbook-logo.png' />
        </div>
        <div className='formBackdrop'>
          <div className='formContainer'>
            <h2 className='title' dangerouslySetInnerHTML={{ __html: title }} />
            {children}
            <div className='gamblingDisclaimer'>
              <p>
                Gambling Problem? Call <a href='tel:18004262537'>1-800-GAMBLER</a> for help
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='footerWrapper'>
        <MinimalFooter
          iconDimensions={{ height: '2rem', width: '2rem' }}
          linkToggles={{ help: false, termsOfUse: true, privacyPolicy: true, subscriptionTerms: false }}
          backgroundColor='#141e30'
          foregroundColor='#fff'
          fontSize='12px'
        />
      </div>
      <GlobalStyles />
      <style jsx>{`
        .screenBackdrop {
          min-height: 80vh;
          height: 100%;
          width: 100%;
          background-image: url('/static/images/sportsbook/mobile-backdrop.jpg');
          background-color: #141e30;
          background-position: top;
          background-attachment: fixed;
          background-size: 100vw auto;
          background-repeat: no-repeat;
          padding: 0 1rem;
        }
        .footerWrapper {
          min-height: 20vh;
          background: #141e30;
          justify-content: center;
          display: flex;
          align-items: center;
        }
        .formBackdrop {
          width: 100%;
          height: auto;
          padding: 30px 20px;
          justify-content: center;
          background: #fff;
          text-align: center;
        }
        .formContainer {
          width: 100%;
          height: auto;
          max-width: 335px;
          margin: 0 auto;
        }
        .logoContainer {
          display: block;
          width: 100%;
          max-width: 300px;
          height: auto;
          padding: 3rem 1rem;
          margin: auto;
          display: block;
          text-align: center;
        }
        .logo {
          height: auto;
          width: 100%;
          margin: 0 auto;
        }
        .title {
          color: #000000;
          font-family: 'IBM Plex Sans Condensed Bold';
          font-size: 24px;
          font-weight: bold;
          letter-spacing: 0;
          line-height: 32px;
          text-align: center;
          margin: 0 0 30px;
        }
        .gamblingDisclaimer p {
          color: #020202;
          font-family: 'IBM Plex Sans Condensed';
          font-size: 11px;
          letter-spacing: 0.5px;
          line-height: 16px;
        }
        .gamblingDisclaimer a {
          color: #1555d0;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .screenBackdrop {
            background-image: url('/static/images/sportsbook/desktop-backdrop.jpg');
            background-size: 100% auto;
            background-position: top center;
            background-color: #141e30;
            padding: 60px 72px 0;
          }
          .formBackdrop {
            height: auto;
            min-height: 550px;
            border-radius: 2px;
            background-image: url('/static/images/sportsbook/stool_and_stars-bg.png');
            background-position: bottom right;
            background-repeat: no-repeat;
          }
          .logoContainer {
            width: auto;
            max-width: 100%;
            height: 95px;
            margin: auto auto 60px;
            padding: 0;
          }
          .logo {
            height: 100%;
            width: auto;
          }
        }
      `}</style>
    </>
  )
}

export default FormPageLayout
